module.exports = __webpack_public_path__ + "static/img/10019 (4).da6b358.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (4).webp
// module id = w7DH
// module chunks = 14